import React, { useEffect, useRef } from 'react';
import { IconButton } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

/**
 * High-contrast close control for settings modals (demo/upgrade-style corner X),
 * with Escape-to-close in capture phase so chart key handlers don't swallow it.
 */
function SettingsModalCloseButton({ onClose }) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      onCloseRef.current?.();
    };
    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, []);

  return (
    <IconButton
      aria-label="Close settings"
      onClick={onClose}
      sx={{
        position: 'fixed',
        top: 'calc(5% - 18px)',
        left: 'calc(90% - 18px)',
        zIndex: 10000,
        color: '#fff',
        bgcolor: '#0d203f',
        border: '1px solid rgba(255,255,255,0.45)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
        width: 36,
        height: 36,
        '&:hover': {
          color: '#fff',
          bgcolor: '#163569',
          borderColor: '#fff',
        },
      }}
    >
      <CancelOutlinedIcon sx={{ fontSize: 26 }} />
    </IconButton>
  );
}

export default SettingsModalCloseButton;
